import { useMarket } from '../i18n';

/**
 * Returns the base URL for the current market.
 * Used in JSON-LD structured data to avoid hardcoding domains.
 */
export function useBaseUrl(): string {
  const market = useMarket();
  return market === 'se' ? 'https://byggenbastu.se' : 'https://saunacreator.com';
}

/**
 * Returns the organization name for the current market.
 */
export function useOrgName(): string {
  const market = useMarket();
  return market === 'se' ? 'Bygg en bastu' : 'Sauna Creator';
}
